<!--
 * @Description:
 * @Date: 2019-03-15 10:04:20
 -->
<template>
  <div>
    <div class="table-box" style="paddingTop:10px">
      <el-button
        @click="back"
        type="text"
        style="display:flex"
        icon="el-icon-arrow-left"
      >
        返回
      </el-button>
      <searchbar :searchEvent="searchEvent.bind(this)" :parent="this" />
      <div>
        <el-table
          style="width: 100%"
          v-loading="loading"
          row-key="questionnaireAnswerId"
          ref="recordList"
          :data="tableData"
          :stripe="false"
          :highlight-current-row="false"
          header-row-class-name="noBorder"
        >
          <!-- <el-table-column
          type="selection"
          width="55"
          row-key="questionnaireAnswerId"
          :reserve-selection="true"
        ></el-table-column> -->
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="80px"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="fullName"
            label="项目参与人"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            v-if="projectStructureType === 2"
            align="center"
            prop="userEnterpriseName"
            label="个体"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="phone"
            label="手机号"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="任务编码"
            prop="taskCode"
          ></el-table-column>
          <el-table-column
            label="服务商审核人"
            align="center"
            v-if="showReviewer"
          >
            <template slot-scope="scope">
              {{ dealReviewer(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="状态"
          >
            <template slot-scope="scope">
              {{ scope.row.auditGongyeStatus | transAuditStatus }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="check(scope.row)">
                查看
              </el-button>
              <el-button
                :disabled="scope.row.auditGongyeStatus !== 1"
                type="text"
                size="small"
                @click="approve(2, scope.row)"
              >
                通过
              </el-button>
              <rejectComponent
                :disabled="scope.row.auditGongyeStatus !== 1"
                @withdraw="item => approve(3, scope.row, 0, item)"
              />
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationData.pageNum"
          :total="totalElements"
          :page-size="paginationData.pageSize"
          layout="total, prev, pager, next, jumper"
          style="padding:15px"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { project, receive } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import taskRecordHandles from '@/Mixin/taskRecordHandles';
import rejectComponent from '@/components/Task/components/reject.vue';
import OpenNewWin from '@/tools/openNewWin';
import searchbar from '@/components/Survey/searchbar';
import { createLogger } from 'vuex';
import approvalFlagMixins from '@/Mixin/approvalFlagMixins';
import { setStorage, getStorage } from '@/tools/storage';

export default {
  mixins: [
    pageInation,
    makeSure,
    taskRecordHandles,
    initSearch,
    approvalFlagMixins
  ],
  data() {
    return {
      ruleForm: {}, // 用户信息
      getList: project.questionnaireAnswerList, // 获取列表的AJAX
      projectStructureType: getStorage('homeProject').projectStructureType || 1,
      searchQuery: {
        projectId: this.$route.query.projectId,
        taskMonth: this.$route.query.month,
        projectType: 5,
        statementId: this.$route.query.statementId,
        ...getStorage('recordsearchQuery')
      },
      month: this.$route.query.month
    };
  },
  components: {
    dicSelect,
    rejectComponent,
    searchbar
  },
  computed: {},
  methods: {
    back() {
      localStorage.removeItem('recordsearchQuery');
      this.$router.back();
    },
    check(item) {
      setStorage('recordsearchQuery', this.searchQuery);
      this.$router.push({
        name: 'surveyRecordDetail',
        query: {
          questionnaireAnswerId: item.questionnaireAnswerId,
          id: this.$route.query.id,
          auditGongyeStatus: item.auditGongyeStatus,
          statementId: this.$route.query.statementId
        }
      });
    },
    exportEvent() {
      if (this.searchQuery.projectId && this.searchQuery.taskMonth) {
        let queryString = this.$querystring.stringify(this.searchQuery);
        window.open(
          project.taskHzDyRecordDiaoyanPageListExportV2 + '?' + queryString
        );
      } else {
        this.$message.error('请选择条件');
      }
    }
  },
  filters: {
    transTag(val) {
      if (val == 0) {
        return '差';
      } else if (val == 1) {
        return '一般';
      } else if (val == 2) {
        return '积极';
      } else if (val == 3) {
        return '好';
      } else if (val == 4) {
        return '很好';
      }
    },
    transAuditStatus(val) {
      // console.log(val);
      if (val == 1) {
        return '审核中';
      } else if (val == 2) {
        return '审核通过';
      } else if (val == 3) {
        return '审核未通过';
      }
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
</style>
